import { render } from "./PrivilegesSection.vue?vue&type=template&id=77e773a9&scoped=true"
import script from "./PrivilegesSection.vue?vue&type=script&lang=js"
export * from "./PrivilegesSection.vue?vue&type=script&lang=js"

import "./PrivilegesSection.vue?vue&type=style&index=0&id=77e773a9&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e773a9"]])

export default __exports__